var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.loading)?_c('div',{staticClass:"ll-load"},[_c('img',{attrs:{"alt":"","src":require("./loading.gif")}})]):_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }